<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Events</h1>
          <v-btn small depressed color="accent" to="/events/create" v-if="$can('create_event')">
            <v-icon small>add</v-icon>Create Event
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="search !== ''">Results for "{{ search }}"</span>
            <span v-else>{{ tableTitle }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="filteredEvents"
            :loading="isLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No events available"
            :hide-actions="events.length < 6"
          >
            <template v-slot:items="props">
              <td>{{ (props.index + 1) }}</td>
              <td>{{ formatDate(props.item.timestamp) }}</td>
              <td class="py-3">
                <router-link
                  :to="'/events/' + props.item._id"
                  v-if="canViewEvent(props.item.agent_id, props.item.state_id)"
                >
                  <b>{{ props.item.title }}</b>
                </router-link>
                <b v-else>{{ props.item.title }}</b>
              </td>
              <td>{{ props.item.affected.toLocaleString() }}</td>
              <td class="py-3">
                {{ props.item.state }}
                <br />
                <span class="grey--text">{{ props.item.location }}</span>
              </td>
              <td>{{ props.item.agency }}</td>
              <td>
                <v-chip
                  small
                  :color="props.item.status === 'ongoing' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>
              <td>
                <router-link
                  :to="'/events/' + props.item._id"
                  v-if="canViewEvent(props.item.agent_id)"
                >
                  <v-icon small>visibility</v-icon>
                </router-link>
                <v-icon small class="ml-2 d-none" @click="deleteEvent(props.item._id)">delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import '@/plugins/google-maps'
import { mapGetters } from 'vuex'
import { EVENT_FETCH } from '@/store/actions/event'
import { STATE_FETCH } from '@/store/actions/state'
import { LOCATION_FETCH } from '@/store/actions/location'
import { AGENCY_FETCH } from '@/store/actions/agency'
import rolesData from '@/data/roles'

export default {
  name: 'Events',
  created () {
    this.isLoading = true
    
    Promise.all([
      this.$store.dispatch(EVENT_FETCH),
      this.$store.dispatch(STATE_FETCH),
      this.$store.dispatch(AGENCY_FETCH),
      this.$store.dispatch(LOCATION_FETCH)
    ]).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      search: this.$route.query.s || '',
      isLoading: false,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Date', value: 'timestamp' },
        { text: 'Title', value: 'title' },
        { text: 'Affected', value: 'affected' },
        { text: 'Location', value: 'state' },
        { text: 'Reported By', value: 'agency' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'location', sortable: false }
      ]
    }
	},
  computed: {
    tableTitle () {
      let title = ''
      if (this.currentUser.role === rolesData.admin || rolesData.agencyAgents.includes(this.currentUser.role)) {
        title = 'All Events'
      }
      else {
        title = `All Events in ${this.$store.getters.stateName(this.currentUser.parent_id)}`
      }
      return title
    },
    filteredEvents () {
      let events = this.events
      if (this.currentUser.role === rolesData.admin || rolesData.agencyAgents.includes(this.currentUser.role)) {
        events = this.events
      }
      else {
        events = this.$store.getters.eventsByField('state_id', this.currentUser.parent_id)
      }
      return events
    },
    ...mapGetters(['events', 'currentUser'])
  },
  methods: {
    canViewEvent (agentId, stateId) {
      return this.currentUser.role === rolesData.admin || 
        rolesData.heads.includes(this.currentUser.role) || 
        (this.currentUser.parent === 'state' && this.currentUser.parent_id === stateId) ||
        this.currentUser._id === agentId
    },
		formatDate (timestamp) {
			return (new Date(timestamp * 1000)).toLocaleDateString(
				'en-US', { year: 'numeric', month: 'long', day: 'numeric' }
			)
    }
  }
}
</script>
